import React, { useState } from "react";
import { toast } from "sonner";
import { X, Send, Loader2 } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function BulkMessageModal({ userIds, onClose, onDone }) {
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (!message.trim()) return;
    setSending(true);
    try {
      const { data } = await api.post("/recruiter/bulk/message", { user_ids: userIds, message: message.trim() });
      toast.success(data.message);
      onDone?.();
      onClose();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Failed to send messages");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center px-4" data-testid="bulk-message-modal">
      <div className="glass-panel rounded-2xl p-6 max-w-md w-full">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading font-semibold text-white text-sm">Message {userIds.length} candidate{userIds.length !== 1 ? "s" : ""}</h3>
          <button onClick={onClose} data-testid="bulk-message-close-btn" className="text-slate-400 hover:text-white"><X className="w-4 h-4" /></button>
        </div>
        <textarea
          value={message} onChange={(e) => setMessage(e.target.value)} rows={5} autoFocus
          placeholder="This message will be sent to all selected candidates..."
          data-testid="bulk-message-textarea"
          className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:ring-1 focus:ring-indigo-400 resize-none"
        />
        <button
          onClick={send} disabled={sending || !message.trim()} data-testid="bulk-message-send-btn"
          className="w-full mt-4 flex items-center justify-center gap-2 bg-primary hover:bg-primary/90 disabled:opacity-60 text-white text-sm font-semibold py-2.5 rounded-lg transition-colors"
        >
          {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Send to {userIds.length}
        </button>
      </div>
    </div>
  );
}
